<template>
  <div class="corp-page">
    <main>
      <div>
        <div class="m-left">
          <h1>{{ hello }}</h1>
          <h1>{{ welcome }}</h1>
          <p>{{ loginApply }}</p>
          <button @click="handleApply">{{ loginButton }}</button>
        </div>
        <div class="m-rig">
          <p>{{ alreadyHave }}</p>
          <input type="text" :placeholder="placeholder1" autofocus>
          <input type="password" :placeholder="placeholder2"><br>
          <input type="checkbox" id="remember">
          <label for="remember">{{ rememberTitle }}</label>
          <a href="#" @click="findPassword">{{ findPasswordTitle }}</a>
          <button @click="handleLogin">{{ loginTitle }}</button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  components: {
  },
  computed: {
    hello() {
      return this.$store.getters.currentLang === 'zh' ? '你好，' : 'こんにちは，'
    },
    welcome() {
      return this.$store.getters.currentLang === 'zh' ? '欢迎来到企业账户系统' : '企業アカウントシステムへようこそ'
    },
    loginApply() {
      return this.$store.getters.currentLang === 'zh' ? '还没有企业账户，请申请' : '企業口座がございませんので、お申し込みください'
    },
    loginButton() {
      return this.$store.getters.currentLang === 'zh' ? '申请企业用户' : '企業のユーザー登録をします'
    },
    alreadyHave() {
      return this.$store.getters.currentLang === 'zh' ? '已有账户，请登录' : '口座があります,ログインしてください'
    },
    placeholder1() {
      return this.$store.getters.currentLang === 'zh' ? '输入你的账号' : 'アカウントを入力します'
    },
    placeholder2() {
      return this.$store.getters.currentLang === 'zh' ? '输入你的密码' : 'パスワードを入力します'
    },
    rememberTitle() {
      return this.$store.getters.currentLang === 'zh' ? '记住密码' : 'パスワードを覚えます'
    },
    findPasswordTitle() {
      return this.$store.getters.currentLang === 'zh' ? '找回密码' : 'パスワードを取り戻します'
    },
    loginTitle() {
      return this.$store.getters.currentLang === 'zh' ? '登录' : '登録します'
    },
  },
  methods: {
    handleApply() {
      window.alert(this.$store.getters.currentLang === 'zh' ? '暂未开放账号申请，请确认' : '口座開設のお申し込みはまだ受け付けておりません ')
    },
    findPassword() {
      window.alert(this.$store.getters.currentLang === 'zh' ? '暂未开放密码找回，请确认' : 'パスワード回復はまだ利用できません ')
    },
    handleLogin() {
      window.alert(this.$store.getters.currentLang === 'zh' ? '账号密码错误，请确认' : 'アカウントのパスワードが間違っています ')
    }
  }
}
</script>

<style scoped lang="scss">
main {
  width: 100%;
  height: 647px;
  background: url("../../assets/images/main_bg2.png") no-repeat;
  background-size: cover;

  >div {
    width: 840px;
    height: inherit;
    margin: 0 auto;

    >.m-left {
      float: left;
      padding-top: 180px;
      width: 420px;
      height: 320px;
      color: #fff;

      >h1 {
        font-weight: 500;
      }

      >p {
        font-size: 0.7rem;
        margin-top: 50px;
        margin-left: 10px;
        margin-bottom: 15px;
      }

      >button {
        color: #fff;
        margin-left: 10px;
        width: 290px;
        height: 44px;
        background: transparent;
        border: 1px solid #fff;
        border-radius: 40px;

        &:focus {
          outline: none;
        }
      }
    }

    // 右侧表单
    >.m-rig {
      margin-top: 130px;
      padding: 37px 31px;
      width: 300px;
      height: 250px;
      background: $write;
      float: right;
      border-radius: 8px;

      >p {
        font-size: 1.3rem;
        margin-bottom: 17px;
        text-align: center;
      }

      >input[type="text"],
      input[type="password"] {
        width: 266px;
        height: 20px;
        padding: 9px 10px;
        margin-top: 8px;
        margin-bottom: 8px;
        border-radius: 6px;
        border: none;
        background: #f0f1f2;
        font-size: 1.1rem;

        &:focus {
          outline: none;
        }
      }

      >input[type="checkbox"] {
        margin-top: 8px;
        margin-right: 5px;
        width: 18px;
        height: 18px;
        float: left !important;
      }

      >label {
        float: left;
        margin-top: 7px;
      }

      >a {
        margin-top: 7px;
        margin-right: 5px;
        float: right;
        text-decoration: underline;
      }

      >button {
        display: inline-block;
        margin-top: 30px;
        width: 247px;
        height: 40px;
        border-radius: 20px;
        border: none;
        background: #78a2cc;
        color: #fff;
        font-size: 1.4rem;

        &:focus {
          outline: none;
        }
      }
    }
  }
}
</style>
  
